// extracted by mini-css-extract-plugin
export var borderRadius = "_9s-4";
export var large = "_9s-3";
export var logoContainer = "_9s-0";
export var nameLogo = "_9s-2";
export var small = "_9s-1";